import axios from "axios";
import React, { useEffect } from "react";
import { genURL } from "../../../_getjson";
import CustomDataGrid from "../../CustomDataGrid/CustomDataGrid";
import CustomSnackbar from "../../Snackbar/Snackbar";
const columns = [
    { field: 'id', headerName: 'ID', width: 90, hide: true },
    {
        field: 'warehouse',
        headerName: 'คลัง',
        width: 200,
        editable: false,
        flex: 0
    }, {
        field: 'warehouseCode',
        headerName: 'warehouseCode',
        width: 30,
        editable: false,
        flex: 1,
        hide: true
    },
    {
        field: 'location',
        headerName: 'ที่เก็บ',
        width: 200,
        editable: false,
        flex: 0
    }, {
        field: 'locationCode',
        headerName: 'locationCode',
        width: 150,
        editable: false,
        flex: 1,
        hide: true
    },
    {
        field: 'unit',
        headerName: 'หน่วยนับ',
        width: 150,
        editable: false,
        flex: 1
    }, {
        field: 'unitCode',
        headerName: 'unitCode',
        width: 150,
        editable: false,
        flex: 1,
        hide: true
    },
    {
        field: 'balance',
        headerName: 'คงเหลือ',
        width: 150,
        editable: false,
        flex: 1,
        hide: false
    },
    {
        field: 'outstandingReceipt',
        headerName: 'ค้างรับ',
        width: 150,
        editable: false,
        flex: 1,
        hide: false
    },
    {
        field: 'overdueDelivery',
        headerName: 'ค้างส่ง',
        width: 150,
        editable: false,
        flex: 1,
        hide: false
    },
    {
        field: 'reserve',
        headerName: 'จอง',
        width: 150,
        editable: false,
        flex: 1,
        hide: false
    }
];
export default function WareHouse_Location(props) {
    const { userCode, productCode } = props
    const [state, setState] = React.useState({
        warehouse: "",
        location: "",
        openDialog: false,
        titleDialog: "เลือกคลังและที่เก็บ",
        multiSelects: false,
        openBackdrop: false,
        openSnackbar: false,
        colorSnackbar: "warning",
        iconSnackbar: <></>,
        messageAlert: "",
        openBackdrop: false,
        rowData: [],
        onLoading: false,
        selectRowData: [],
        selectionModel: []
    })



    useEffect(() => {
        loadData(productCode)
        return () => {
        }
    }, [productCode])
    const loadData = async (productCodeInRow, search) => {
        console.log("loadDataProductCodeInRow", productCodeInRow);
        await setState((prevState) => ({
            ...prevState,
            onLoading: true
        }))
        let SearchCode = ""
        let item = [];
        var url = "csstkwarehouses/allStkWarehouse?productCode=" + productCodeInRow
        // +
        // (Search === "Y" ? "&typesearch=" + state.selected + "&txtsearch=" + Code.current.value : "")
        console.log("urlSTKWAREHOUSE", genURL(url));
        let arrData = [];
        await axios.get(genURL(url)).then(res => {
            if (res.status === 200) {
                //   console.log("urlSTKWAREHOUSE res", res) 
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data[0].Data.length; i++) {
                        console.log(res.data[0].Data[i].WAREHOUSE)
                        item[i] = {
                            id: i + 1,
                            rowNumber: i + 1,
                            warehouse: res.data[0].Data[i].WHNAME,
                            warehouseCode: res.data[0].Data[i].WAREHOUSE,
                            location: res.data[0].Data[i].LOCNAME,
                            locationCode: res.data[0].Data[i].LOCATION,
                            unit: res.data[0].Data[i].UNITNAME,
                            unitCode: res.data[0].Data[i].UNITCODE,
                            balance: res.data[0].Data[i].STOCKQTY,
                            outstandingReceipt: res.data[0].Data[i].PURCHASEORDER, // ค้างรับ
                            overdueDelivery: res.data[0].Data[i].CUSTORDER, //ค้างส่ง
                            reserve: res.data[0].Data[i].SALEORDER //จอง
                        }
                        //   console.log(item[i])
                        arrData.push(item[i])
                    }
                }
            }

        })

        await setState((prevState) => ({
            ...prevState,
            rowData: arrData,
            openBackdrop: false,
            onLoading: false
        }))
        // await console.log("state.rowData", state.rowData)
    }

    useEffect(() => {
        console.log("useEffect state.rowData", state.rowData, "state.rowData.length", state.rowData.length)
        return () => {
        }
    }, [state.rowData])


    const handleDoubleClick = async (e) => {
        // console.log(selectionModel); 
        // f
        let result = []
        if (state.selectionModel.length > 0) {
            result = await data.filter((elem) => {
                return state.selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            await result.push(e.row)
        }
        await props.resultData(result)
    }

    return (<>
        {state.onLoading === false && state.rowData.length > 0 ? <CustomDataGrid
            option={[{ add: false, del: false, select: false }]}
            datacolumns={columns}
            datarows={state.rowData}
            Dataintable={(e) => {
                // props.resultData(e);
            }}
            hideFooters={false}
            editModes={"cell"}
            startRow={30}
            checkboxSelections={false}
            Dataintableremove={(e) => console.log(e)}
            disableSelectionOnClicks={true}
            selectionModel={state.selectionModel}
            onRowDoubleClick={e => handleDoubleClick(e)}


        /> : "กำลังโหลด"
        }
        <CustomSnackbar place="br"
            color={state.color}
            icon={state.icon}
            autoClose={state.autoClose}
            message={state.messagealert}
            open={state.opensnackbar}
            closeNotification={() => {
                setState((prevState) => ({
                    ...prevState,
                    openSnackbar: false
                }))
            }}
            close />
    </>
    )
}